var map = {
	"./Dolce & Gabbana.png": 1329,
	"./Group1.png": 9344,
	"./Group2.png": 7675,
	"./Group3.png": 3458,
	"./H&M.png": 2827,
	"./bag1.png": 3361,
	"./bag2.png": 3194,
	"./bag3.png": 4419,
	"./bag4.png": 4252,
	"./baseHero.png": 8089,
	"./biba.png": 6126,
	"./chanel.png": 8753,
	"./hero.png": 6990,
	"./heroCategory.png": 6914,
	"./logo.png": 8239,
	"./logoCheckout/amazon.png": 1668,
	"./logoCheckout/appel.png": 3644,
	"./logoCheckout/googlepay.png": 6475,
	"./logoCheckout/master.png": 2898,
	"./logoCheckout/path36.png": 6482,
	"./logoCheckout/paytm.png": 4097,
	"./logoCheckout/upi.png": 6354,
	"./prada.png": 7830,
	"./skincare-one.png": 237,
	"./skincare.png": 5530,
	"./zara.png": 1406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;